export default __webpack_public_path__ + "static/media/Padron_Executive.20be9ce2.jpg";